function handleDrawerMenu() {
  const hamburgerMenu = document.getElementById("header-new__menu-icon");
  const menuDrawerNav = document.getElementById("menu-drawer-nav");
  const closeMenuDrawer = document.getElementById("menu-drawer-close");
  const headerNewInner = document.querySelector(".header-new__inner");

  if (!hamburgerMenu || !menuDrawerNav || !closeMenuDrawer || !headerNewInner)
    return;

  // Click to open menu drawer
  hamburgerMenu.addEventListener("click", () => {
    menuDrawerNav.classList.toggle("hide-this");
    // If menu drawer is open, set the header new inner to the width of the menu drawer
    if (!menuDrawerNav.classList.contains("hide-this")) {
      headerNewInner.style.transform = `translateX(${menuDrawerNav.clientWidth}px)`;
      menuDrawerNav.style.transform = "translateX(0)";
    } else {
      headerNewInner.style.transform = "translateX(0)";
      menuDrawerNav.style.transform = "translateX(-100%)";
    }
  });

  // Click to close menu drawer
  closeMenuDrawer.addEventListener("click", () => {
    menuDrawerNav.classList.add("hide-this");
    headerNewInner.style.transform = "translateX(0)";
  });

  // Click outside of menu drawer to close
  document.addEventListener("click", (e) => {
    if (
      !menuDrawerNav.contains(e.target) &&
      !hamburgerMenu.contains(e.target)
    ) {
      menuDrawerNav.classList.add("hide-this");
      headerNewInner.style.transform = "translateX(0)";
    }
  });

  // Escape key to close menu drawer
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      menuDrawerNav.classList.add("hide-this");
      headerNewInner.style.transform = "translateX(0)";
    }
  });
}

function closeOtherAccordions() {
  const menuDetails = document.querySelectorAll("details.menu-details");

  if (!menuDetails.length) return;

  menuDetails.forEach((detail) => {
    detail.addEventListener("toggle", () => {
      // Only run this code when a details element is being opened
      if (detail.open) {
        const level = detail.classList.contains("level-1")
          ? "level-1"
          : detail.classList.contains("level-2")
          ? "level-2"
          : "level-3";

        // Find all other details at the same level that are currently open
        const siblingDetails = document.querySelectorAll(
          `details.menu-details.${level}`
        );

        siblingDetails.forEach((sibling) => {
          // Don't close the detail that was just opened
          if (sibling !== detail && sibling.open) {
            sibling.open = false;
          }
        });
      }
    });
  });
}

function stickDrawerMenuUnderAnnouncementBar() {
  const announcementBar = document.querySelector(".ombraz-abtest-announcement");
  const menuDrawerNav = document.getElementById("menu-drawer-nav");

  if (!announcementBar || !menuDrawerNav) return;

  const announcementBarHeight = announcementBar.offsetHeight;
  const currentDeviceWidth = getCurrentDeviceWidth();

  if (currentDeviceWidth <= 768) {
    menuDrawerNav.style.top = `${announcementBarHeight - 3}px`;
    menuDrawerNav.style.height = `calc(100vh - ${announcementBarHeight}px)`;
    menuDrawerNav.style.maxHeight = `calc(100vh - ${announcementBarHeight}px)`;
  } else {
    const topPosition = Math.max(0, announcementBarHeight);
    menuDrawerNav.style.top = `${topPosition}px`;

    const availableHeight = window.innerHeight - topPosition;
    menuDrawerNav.style.height = `${availableHeight}px`;
    menuDrawerNav.style.maxHeight = `${availableHeight}px`;
  }
}

function stickAlwaysUnderAnnouncementBarWhenSroll() {
  const announcementBar = document.querySelector(".ombraz-abtest-announcement");
  const menuDrawerNav = document.getElementById("menu-drawer-nav");

  if (!announcementBar || !menuDrawerNav) return;

  const announcementBarHeight = announcementBar.clientHeight;
  const scrollPosition = window.scrollY;

  // Calculate the top position
  const topPosition = Math.max(0, announcementBarHeight - scrollPosition);
  menuDrawerNav.style.top = `${topPosition}px`;

  // Calculate the available height for the drawer
  const availableHeight = window.innerHeight - topPosition;
  menuDrawerNav.style.height = `${availableHeight}px`;
  menuDrawerNav.style.maxHeight = `${availableHeight}px`;

  // If in mobile device the top -5
  if (getCurrentDeviceWidth() <= 768) {
    menuDrawerNav.style.top = `${topPosition - 5}px`;
  }
}

function getCurrentDeviceWidth() {
  return window.innerWidth;
}

document.addEventListener("DOMContentLoaded", () => {
  handleDrawerMenu();
  closeOtherAccordions();
  stickDrawerMenuUnderAnnouncementBar();
});

window.addEventListener("scroll", () => {
  stickAlwaysUnderAnnouncementBarWhenSroll();
});

window.addEventListener("resize", () => {
  stickDrawerMenuUnderAnnouncementBar();
});
